import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshCw, X } from 'lucide-react';
import { fetchLatestBundle, runningBundle } from '../utils/runningBuild';
import './NewVersionNotice.css';

const CHECK_EVERY_MS = 5 * 60 * 1000;
const SNOOZE_MS = 30 * 60 * 1000;

export default function NewVersionNotice() {
  const { t } = useTranslation('common');
  const [stale, setStale] = useState(false);
  const [snoozedUntil, setSnoozedUntil] = useState(0);

  const check = useCallback(async () => {
    const running = runningBundle();
    if (!running) return;
    const latest = await fetchLatestBundle().catch(() => null);
    if (latest && latest !== running) setStale(true);
  }, []);

  useEffect(() => {
    check();
    const timer = setInterval(check, CHECK_EVERY_MS);
    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [check]);

  if (!stale || Date.now() < snoozedUntil) return null;

  return (
    <div className="new-version-notice" role="status">
      <span>{t('newVersion.text')}</span>
      <button type="button" className="new-version-reload" onClick={() => window.location.reload()}>
        <RefreshCw size={15} />
        {t('newVersion.reload')}
      </button>
      <button
        type="button"
        className="new-version-close"
        aria-label={t('newVersion.later')}
        title={t('newVersion.later')}
        onClick={() => setSnoozedUntil(Date.now() + SNOOZE_MS)}
      >
        <X size={16} />
      </button>
    </div>
  );
}
